import DatePickerController from './date-picker.controller';
import { DatePickerProps } from './date-picker.model';

const DatePicker = (props: DatePickerProps): JSX.Element => {
  return <DatePickerController {...props} />;
};
export default DatePicker;
